import { useCallback, useState } from 'react'
import { useWeb3React } from '@web3-react/core'
import useToast from 'hooks/useToast'
import { useTranslation } from 'contexts/Localization'
import { useAppDispatch } from 'state'
import { fetchMultiPoolUserDataAsync } from 'state/multiPool'
import { getRewardMultiPool } from 'utils/calls'
import { useMultiPoolContract } from 'hooks/useContract'

const useGetRewardMultiPool = () => {
  const dispatch = useAppDispatch()
  const { toastSuccess, toastError } = useToast()
  const { t } = useTranslation()
  const { account } = useWeb3React()
  const [isGettingReward, setIsGettingReward] = useState(false)
  const multiPoolContract = useMultiPoolContract()

  const handleGetRewardMultiPool = useCallback(
    async () => {
      try {
        setIsGettingReward(true)
        const status = await getRewardMultiPool(multiPoolContract)

        if (status) {
          toastSuccess(
            `${t('Succeed')}!`,
            t('Your reward has been transferred to your wallet!'),
          )
          dispatch(fetchMultiPoolUserDataAsync(account))
        } else {
          toastError(
            t('Error'),
            t('Please try again. Confirm the transaction and make sure you are paying enough gas!'),
          )
        }

        setIsGettingReward(false)
      } catch (e) {
        console.error(e)
        toastError(
          t('Error'),
          t('Please try again. Confirm the transaction and make sure you are paying enough gas!'),
        )
        setIsGettingReward(false)
      }
    },
    [dispatch, t, toastSuccess, toastError, account, multiPoolContract],
  )

  return { handleGetRewardMultiPool, isGettingReward }
}

export default useGetRewardMultiPool
